import { JobProgress } from '../common/JobProgress';

interface Props {
    isLoading: boolean;
    onEvaluate: () => void;
    onCancelMeepMeep?: () => void;
    loadingMode?: 'evaluate' | 'quantarc' | 'meepmeep' | null;
    loadingMessage?: string | null;
    loadingStage?: string | null;
    currentDayCount?: number | null;
    totalDayCount?: number | null;
    progressPct?: number | null;
}

export function EvaluateHeader({
    isLoading,
    onEvaluate,
    onCancelMeepMeep,
    loadingMode,
    loadingMessage,
    loadingStage,
    currentDayCount,
    totalDayCount,
    progressPct,
}: Props) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <button
                onClick={() => onEvaluate()}
                disabled={isLoading}
                style={{
                    background: isLoading
                        ? 'var(--text-muted)'
                        : 'linear-gradient(135deg, var(--accent-success) 0%, var(--nature-fundamental) 100%)',
                    color: 'white',
                    padding: '0.75rem 1.5rem',
                    borderRadius: 'var(--radius-md)',
                    border: 'none',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    boxShadow: isLoading ? 'none' : 'var(--shadow-focus-success)',
                    transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                    if (!isLoading) {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = 'var(--shadow-focus-success-hover)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isLoading) {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'var(--shadow-focus-success)';
                    }
                }}
            >
                {isLoading ? "⏳ Calculating..." : "🚀 Calculate"}
            </button>

            {isLoading && loadingMode === 'meepmeep' && (
                <JobProgress 
                    loadingStage={loadingStage}
                    loadingMessage={loadingMessage}
                    currentDayCount={currentDayCount}
                    totalDayCount={totalDayCount}
                    progressPct={progressPct}
                    onCancel={onCancelMeepMeep}
                />
            )}
        </div>
    );
}
